import ms from "ms";
import { makeHook } from "../../utils/makeSingleArgHook";
import getFeedsSummaryV2, { feedsSummaryUrlV2, } from "../requests/getFeedsSummary.v2";
const useGetFeedsSummaryV2 = makeHook(async (personId, auth) => getFeedsSummaryV2(personId, auth), (personId) => [feedsSummaryUrlV2(personId)], {
    staleTime: ms("2 minutes"),
    refetchInterval: ms("2 minutes"),
    refetchOnWindowFocus: true,
});
export default useGetFeedsSummaryV2;
//# sourceMappingURL=useGetFeedsSummaryV2.js.map